const mobileBar = {
  el: $('.mobile-bar'),
  init() {
    this.click();
    this.triggerHide();
  },
  showBar() {
    this.el.addClass('mobile-bar--show');
  },
  hideBar() {
    this.el.removeClass('mobile-bar--show');
  },
  open(el) {
    $('.header__mobile-menu').addClass('active');
    el.addClass('active');
    el.find('.mobile-bar__icon span').removeClass().addClass('icon-close');
  },
  close(el) {
    $('.header__mobile-menu').removeClass('active');
    el.removeClass('active');
    el.find('.mobile-bar__icon span').removeClass().addClass('icon-menu');
  },
  click() {
    const btn = this.el.find('.mobile-bar__col--menu');
    const self = this;
    btn.on('click', function (e) {
      e.preventDefault();
      const thisBtn = $(this);
      if (!thisBtn.hasClass('active')) {
        // open
        self.open(thisBtn);
        bodyScrollLock.disableBodyScroll();
      } else {
        // close
        self.close(thisBtn);
        bodyScrollLock.enableBodyScroll();
      }
    });
  },
  triggerHide() {
    $(window).on('scroll', debounce(() => {
      if ((window.innerHeight + Math.ceil(window.scrollY)) >= document.body.offsetHeight) {
        this.hideBar();
      } else {
        this.showBar();
      }
    }, 100));
  }
};

$(document).ready(() => {
  if (mobileBar.el.length > 0) {
    mobileBar.init();
  }
});